import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5604c64c: FaireBrandEntity = {
  token: "b_5604c64c",
  type: "brand",
  name: "Taylor Elliott Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/7b63307c90ad9586683e57f967f8793304a3ca0f77b6487583a86ee5f1a55535.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0fa69ae6f19f0ffa7fc0a5aae7c886a7e08d2b734edf24664048853746c9f1f1.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7b63307c90ad9586683e57f967f8793304a3ca0f77b6487583a86ee5f1a55535.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0fa69ae6f19f0ffa7fc0a5aae7c886a7e08d2b734edf24664048853746c9f1f1.png",
  location: "OK, USA",
  minimumOrderDollars: 350,
  rating: 5,
  reviewCount: 534,
  isTopShop: true,
  isInsider: true,
  description:
    "Taylor is inspired by her customers, who love charming, colorful and fun products. She specializes in motivational, colorful and FUN-to-use gift items and desk accessories for women who love charming, playful and adventurous styles. Nothing brings more joy to Taylor than seeing happy customers gifting and enjoying her products.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:29.577Z",
    importedBy: "entity-db-cli",
  },
};
